<template>
  <div class="col-12 px-0 b-page b-page_height_auto">
    <div class="b-page__content">
      <main class="b-main__inner">
        <div class="py-4 px-6 b-toolbar">
          <div class="b-toolbar__inner">
            <div class="mr-4 b-toolbar__item b-import__choose">
              <ButtonWithDropdown
                :importData="importData"
                :btnText="$t('CONTENT.import')"
                :tooltip-text="$t('CONTENT.hints.importCurrencyHint')"
                iconName="xls"
                @onChooseValue="openImportDialog($event)"
              ></ButtonWithDropdown>
            </div>
            <div class="mr-3 b-toolbar__item b-import__choose">
              <ButtonWithDropdown
                :importData="importData"
                :btnText="$t('CONTENT.download_template')"
                iconName="download"
                @onChooseValue="createDownloadLink($event)"
              ></ButtonWithDropdown>
            </div>
          </div>
        </div>
        <form class="b-form b-currency__filter px-6 my-4" @submit.prevent="onSubmit">
          <div class="row b-form__row_type_flex-end">
            <div class="col-2">
              <div>
                <label>{{$t('CONTENT.currency.currencyRate_period')}}:</label>
                <cool-select :list="currencyRateMonths"
                             option-value="value"
                             option-text="name"
                             v-model="currencyRateMonth"
                             :placeholder="$t('CONTENT.choose')"
                             @change="selectCurrencyRateMonth($event)"></cool-select>
              </div>
            </div>
            <div class="col-2" data-cy="payment-lease-rate">
              <numeric class="b-numeric" controls :min="1990" v-model="currencyRateYear" @keypress="changeNumericValue($event)"></numeric>
            </div>
            <div class="col-2">
              <label>{{$t('CONTENT.currency.currencyRates')}}:</label>
              <cool-select :list="allCurrencyCode"
                           option-value="code"
                           option-text="name"
                           :placeholder="$t('CONTENT.choose')"
                           v-model="currentCurrencyCode"></cool-select>
            </div>
            <div class="col-2">
              <label>{{$t('CONTENT.currency.currencyRate_source')}}:</label>
              <cool-select :list="currencyRateSources"
                           option-value="value"
                           option-text="name"
                           v-model="currencyRateSource"
                           :placeholder="$t('CONTENT.choose')"
                           @change="selectCurrencyRateSource($event)"></cool-select>
            </div>
          </div>
        </form>
        <div class="b-table b-full-table b-full-table_type_short mx-6 mb-10">
          <div class="b-table__row b-full-table__row b-full-table__row-header">
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$t('CONTENT.date')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{systemSettingsCurrencyCode}} / {{currentCurrencyCode.toUpperCase()}}</div>
          </div>
          <div
            class="b-table__row b-full-table__row"
            v-for="date in convertedDates"
            :key="date.asString + currentCurrencyCode + currencyRateSource"
          >
            <div class="b-table__cell b-full-table__cell">{{date.asDate}}</div>
            <div class="b-table__cell b-full-table__cell">
              <CurrencyRateWidgetSmall
                :currencyCode="currentCurrencyCode.toUpperCase()"
                :onDateAsString="date.asString"
                :source="currencyRateSource"
              />
            </div>
          </div>
        </div>
        <popup name="currency-import-popup" height="auto" :scrollable="true">
          <ImportDialogWidget
            v-if="isShowImportDialog && importType !== null"
            :importType="importType"
            :importedCourseNames="importedCourseNames"
            @close="closeImportDialog"
          ></ImportDialogWidget>
        </popup>
      </main>
    </div>
  </div>
</template>
<script>
import CurrencyRateWidgetSmall from "../../widgets/CurrencyRateWidgetSmall";
import downloadFileMixin from "../../../mixins/downloadFile";
import ImportDialogWidget from "../../widgets/ImportDialogWidget";
import { mapGetters } from "vuex";
import DateWithoutTimeAPI from "../../../api/DateWithoutTimeAPI.js";
import dateConverter from "../../../utils/converters/date.converter.js";
import changeNumericValue from "../../../mixins/changeNumericValue";
import ButtonWithDropdown from "../../shared/ButtonWithDropdown";
import CurrencyRate from "../../../api/CurrencyRate";

export default {
  components: {
    ImportDialogWidget,
    CurrencyRateWidgetSmall,
    ButtonWithDropdown,
  },
  data() {
    return {
      isShowImportDialog: false,
      currencyRateMonth: 1,
      currencyRateYear: 2019,
      currencyCode: "USD",
      currencyRateSource: "CBR API",
      importType: null,
      dates: [],
      importedCourseNames: [],
    };
  },
  mixins: [downloadFileMixin, changeNumericValue],
  created() {
		this.getDates();
    this.getImportedCourseNames();
	},
  computed: {
    ...mapGetters(["getCurrencyCode"]),
    ...mapGetters(["getContractSettings"]),
    currencyRateMonths() {
      return [
        { value: 1, name: this.$t('CONTENT.months.jan')},
        { value: 2, name: this.$t('CONTENT.months.feb')},
        { value: 3, name: this.$t('CONTENT.months.mar')},
        { value: 4, name: this.$t('CONTENT.months.apr')},
        { value: 5, name: this.$t('CONTENT.months.may')},
        { value: 6, name: this.$t('CONTENT.months.jun')},
        { value: 7, name: this.$t('CONTENT.months.jul')},
        { value: 8, name: this.$t('CONTENT.months.aug')},
        { value: 9, name: this.$t('CONTENT.months.sept')},
        { value: 10, name: this.$t('CONTENT.months.oct')},
        { value: 11, name: this.$t('CONTENT.months.nov')},
        { value: 12, name: this.$t('CONTENT.months.dec')}
      ]
    },
    currencyRateSources() {
      return [
        { value: "CBR API", name: `${this.$t('CONTENT.currency.currencyRate_CBR')}` },
        ...this.importedCourseNames,
      ];
    },
    importData() {
      return [
        {
          text: this.$t("CONTENT.currency.currency_rate"),
          value: "currencyRate"
        },
        {
          text: this.$tc('CONTENT.currency.currency_code', 2),
          value: "currency"
        },
      ]
    },
    systemSettingsCurrencyCode() {
      return this.getContractSettings.currencyCode;
    },
    allCurrencyCode() {
      return this.getCurrencyCode;
    },
    currentCurrencyCode: {
      get() {
        return this.currencyCode.toLowerCase();
      },
      set(newVal) {
        this.currencyCode = newVal.toUpperCase();
      }
    },
    convertedDates() {
      const converted = [];
      for (let i = 0; i < this.dates.length; i++) {
        const element = this.dates[i];
        const asDate = dateConverter.convertToDate(element);
        const convertedDate = this.$d(asDate);
        converted.push({
          asString: element,
          asDate: convertedDate
        });
      }
      return converted;
    }
  },
  watch: {
    currencyRateMonth(val, oldVal) {
			if(oldVal !== val && oldVal !== null) {
				this.recalculateCurrencyRate();
			}
    },
    currencyRateYear(val, oldVal) {
			if(oldVal !== val && oldVal !== null) {
				this.recalculateCurrencyRate();
			}
    },
    currentCurrencyCode(val, oldVal) {
			if(oldVal !== val && oldVal !== null) {
				this.recalculateCurrencyRate();
			}
    },
    currencyRateSource(val, oldVal) {
			if(oldVal !== val && oldVal !== null) {
				this.recalculateCurrencyRate();
			}
    }
  },
  methods: {
    async recalculateCurrencyRate() {
			await this.getDates();
    },
    openImportDialog(importType) {
      this.importType = importType;
      this.isShowImportDialog = true;
      this.$modal.show('currency-import-popup');
    },
    closeImportDialog() {
      this.isShowImportDialog = false;
      this.$modal.hide('currency-import-popup');
    },
    selectCurrencyRateMonth(value) {
      this.currencyRateMonth = value;
    },
    createDownloadLink(importType) {
      this.importType = importType;
      this.downloadTemplate();
    },
    selectCurrencyRateSource(value) {
      this.currencyRateSource = value;
    },
    async getDates() {
      const api = new DateWithoutTimeAPI();
			this.dates = await api.getDatesInMont(
        this.currencyRateMonth,
        this.currencyRateYear
      );
    },
    async getImportedCourseNames() {
      const api = new CurrencyRate();
      api.getImportedCourseNames()
        .then((data) => {
          this.importedCourseNames = data.map(elem => ({ name: elem.fileName, value: elem.fileId }));
        });
    },
  },
};
</script>
